module.exports = __webpack_public_path__ + "static/media/towed-plane.7168fcca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/towed-plane.png
// module id = 377
// module chunks = 3